module.exports = __webpack_public_path__ + "static/media/logo_nemali_horizontal.255cea8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo_nemali_horizontal.png
// module id = 972
// module chunks = 0